import { AlertTriangle, RefreshCw, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const siteAssignmentError = (error) => {
  const body = error.response?.data;
  const detail = body?.detail;
  const message = typeof detail === 'string' ? detail
    : typeof detail?.message === 'string' ? detail.message
    : typeof body?.message === 'string' ? body.message : null;
  const conflict = error.response?.status === 409;
  return {
    conflict,
    message: message || (conflict
      ? 'Un conflit empêche cette affectation. Rechargez le profil avant de réessayer.'
      : error.response
        ? 'Le rattachement au site n’a pas pu être enregistré.'
        : 'Impossible de confirmer l’enregistrement. Rechargez le profil pour vérifier le site actuel.'),
  };
};

export const EmployeeSiteAssignmentNotice = ({ issue, busy, onCancel, onReload }) => {
  if (!issue) return null;
  return (
    <div role="alert" className={`border rounded-md p-4 space-y-3 ${issue.conflict ? 'border-amber-300 bg-amber-50 text-amber-900' : 'border-red-200 bg-red-50 text-red-800'}`} data-testid={issue.conflict ? 'employee-site-feedback-conflict' : 'employee-site-feedback-error'}>
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
        <p className="text-sm break-words min-w-0" data-testid="employee-site-issue-message">{issue.message}</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button type="button" className="h-auto min-h-9 max-w-full whitespace-normal text-left" variant="outline" disabled={busy} onClick={onCancel} data-testid="employee-site-change-cancel"><X className="w-4 h-4" />Annuler la modification</Button>
        <Button type="button" className="h-auto min-h-9 max-w-full whitespace-normal text-left" variant="outline" disabled={busy} onClick={onReload} data-testid="employee-site-profile-reload"><RefreshCw className="w-4 h-4" />Recharger le profil</Button>
      </div>
    </div>
  );
};